import React from 'react';
import BaseIcon from 'src/shared/components/BaseIcon';
import { IconTypeValues } from 'src/shared/config/IconType';
import styles from './styles.module.scss';
import classNames from 'classnames';

interface Props {
    icon: IconTypeValues;
    title: string;
    description: string;
    isLast?: boolean;
}

const FeatureColumn = (props: Props) => {
    const containerClassName = classNames(styles.container, { [styles.last]: props.isLast });
    return (
        <div className={containerClassName}>
            <div className={styles.icon}>
                <BaseIcon type={props.icon} color="primary" fontSize="50px" />
            </div>
            <div className={styles.content}>
                <p className={styles.title}>{props.title}</p>
                <p className={styles.description}>{props.description}</p>
            </div>
        </div>
    );
};

FeatureColumn.defaultProps = {
    isLast: false,
};

export default FeatureColumn;
